(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function updateProgress(rail, bar) {
    if (!rail || !bar) return;
    var max = rail.scrollWidth - rail.clientWidth;
    var ratio = max > 0 ? rail.scrollLeft / max : 0;
    bar.style.width = Math.max(12, Math.round(ratio * 100)) + '%';
  }

  function bindRails() {
    document.querySelectorAll('[data-cfp-rail]').forEach(function (section) {
      var rail = section.querySelector('[data-cfp-track]');
      var bar = section.querySelector('[data-cfp-progress]');
      var prev = section.querySelector('[data-cfp-prev]');
      var next = section.querySelector('[data-cfp-next]');
      if (!rail) return;

      var step = function () {
        return Math.max(rail.clientWidth * 0.7, 280);
      };

      if (prev) {
        prev.addEventListener('click', function () {
          rail.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          rail.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      rail.addEventListener('scroll', function () {
        updateProgress(rail, bar);
      });
      updateProgress(rail, bar);
    });
  }

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = modal.querySelector('[data-cfp-close]');
    if (close) close.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function bindModals() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cfp-open]');
      if (opener) {
        event.preventDefault();
        openModal(opener.getAttribute('data-cfp-open'));
        return;
      }
      var closer = event.target.closest('[data-cfp-close]');
      if (closer) {
        closeModal(closer.closest('.cfp-modal'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        document.querySelectorAll('.cfp-modal:not([hidden])').forEach(closeModal);
      }
    });
  }

  ready(function () {
    bindRails();
    bindModals();
  });
})();
